import { render } from "./InvoicesPage.vue?vue&type=template&id=1ea056eb"
import script from "./InvoicesPage.vue?vue&type=script&lang=js"
export * from "./InvoicesPage.vue?vue&type=script&lang=js"

import "./InvoicesPage.vue?vue&type=style&index=0&id=1ea056eb&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__